<template>
  <el-dialog :visible.sync="dialogVisible" @close='closeDialog' width="300px" :title="dialogStatus ? '确认用户信息' : '新增管理员'">
    <div style="display: flex; flex-direction: column; align-items: center">
      <el-input v-model="phone" v-if="!dialogStatus" placeholder="输入手机号" class="padding width-200"></el-input>
      <div v-else style="display: flex; align-items: center; width: 100%; padding-bottom: 20px;">
        <img style="width:50px;height:50px;border-radius:8px;" :src="userInfo.avatar_url">
        <div style="margin-left: 10px;">{{userInfo.nickname}}</div>
      </div>
      <div>
        <el-button
          type="primary"
          @click="clickDialogButton"
          :loading="dialogButtonLoading"
          :disabled="!this.phone">
          {{dialogStatus ? '确认添加' : '查找'}}
        </el-button>
        <el-button v-if="dialogStatus" @click="resetDialogInfo">返回</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogModal',
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      phone: '',
      dialogStatus: false,
      searchUserUrl: this.getDomain() + 'bmpopularize/get_info_by_keyword',
      setPopularizeManagerUrl: this.getDomain() + 'bmpopularize/set_popularize_manager',
      userInfo: {}
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    }
  },
  methods: {
    clickDialogButton () {
      if (this.dialogStatus) {
        this.setPopularizeManager()
      } else {
        this.searchUser()
      }
    },
    setPopularizeManager () {
      let params = {
        username: this.userInfo.username,
        client_id: this.userInfo.client_id
      }
      let handle = () => {
        this.$message.success('添加成功')
        this.dialogVisible = false
        this.$emit('getList')
      }
      this.__axios(this.setPopularizeManagerUrl, params, handle)
    },
    searchUser () {
      let params = {
        phone: this.phone || ''
      }
      let handle = res => {
        if (!res.data.content.user_info) {
          this.$message.error('不存在此用户')
        } else {
          this.userInfo = res.data.content.user_info
          this.dialogStatus = true
        }
      }
      this.__axios(this.searchUserUrl, params, handle)
    },
    resetDialogInfo () {
      this.dialogStatus = false
    },
    closeDialog () {
      this.dialogStatus = false
      this.phone = ''
    }
  }
}
</script>

<style scoped>

  .padding {
    padding: 10px;
  }

  .width-200 {
    width: 200px;
  }
</style>
